import { render, staticRenderFns } from "./RespostaComprovante.vue?vue&type=template&id=233d21af&"
import script from "./RespostaComprovante.vue?vue&type=script&lang=js&"
export * from "./RespostaComprovante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports